import React, { useState } from "react";
import { ChatStyles } from "./ChatStyles";
import profileLogo from "../../assets/svgs/profile-16-logo.svg";
import {
  Box,
  Typography,
  useMediaQuery,
  IconButton,
  TextField,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { PROFILE_LOGO } from "../../constants";
import { getCookie } from "../../utils/Utility";
import EditIcon from "@mui/icons-material/Edit";

import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { useLocation, useParams } from "react-router-dom";
import { RootState } from "../../store/store";
import { useAppSelector } from "../../store/hooks";

export interface NoteDetails {
  id: string;
  providerId: string;
  customerId: string;
  createdTime: string;
  note: string;
}

export interface ChatProps {
  personChat: any;
  index: number;
  onSave: (
    id: string,
    updatedNote: string,
    providerId: number | string,
    customerId: string | undefined
  ) => void;
  onDelete: (id: string) => void;
}
const formatDateTime = (isoString: string): string => {
  const date = new Date(isoString);
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${month}-${day}-${year} ${hours}:${minutes}:${seconds}`;
};

const Chat: React.FC<ChatProps> = ({ personChat, index, onSave, onDelete }) => {
  const { customerId } = useParams();

  const agentName = getCookie("name");
  const providerId = getCookie("id");
  const isMobile = useMediaQuery("(max-width:1023px)");

  const chatStyle = index % 2 === 0 ? ChatStyles.chat : ChatStyles.userChat;
  const [isEditing, setIsEditing] = useState(false);
  const [editedNote, setEditedNote] = useState(personChat.note);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  // Save Handler
  const handleSave = () => {
    onSave(personChat.id, editedNote, providerId, customerId);
    setIsEditing(false);
    setSnackbarMessage("Note updated successfully!");
    setOpenSnackbar(true);
  };
  const handleDelete = () => {
    setOpenDialog(true);
  };
  const confirmDelete = () => {
    onDelete(personChat.id);
    setSnackbarMessage("Note deleted successfully!");
    setOpenSnackbar(true);
    setOpenDialog(false);
  };
  return (
    <Box sx={chatStyle}>
      {/* If Editing, Show Input Field */}
      {isEditing ? (
        <TextField
          fullWidth
          size="small"
          value={editedNote}
          onChange={(e) => setEditedNote(e.target.value)}
        />
      ) : (
        <Typography sx={ChatStyles.message}>{personChat.note}</Typography>
      )}

      <Box sx={ChatStyles.userDetails}>
        {!isMobile && <img src={profileLogo} alt={PROFILE_LOGO} />}
        <Box sx={ChatStyles.clientChat}>
          <Typography sx={ChatStyles.clientDetails}>{agentName}</Typography>
          <Typography sx={ChatStyles.clientDetails}>|</Typography>
          <Typography sx={ChatStyles.clientDetails}>
            {formatDateTime(personChat?.createdTime)}
          </Typography>
        </Box>

        {/* Action Buttons */}
        <Box sx={{ display: "flex", gap: "4px", ml: "auto" }}>
          {isEditing ? (
            <>
              <IconButton color="success" size="small" onClick={handleSave}>
                <CheckIcon fontSize="small" />
              </IconButton>
              <IconButton
                color="error"
                size="small"
                onClick={() => setIsEditing(false)}
              >
                <CancelIcon fontSize="small" />
              </IconButton>
            </>
          ) : (
            <>
              <IconButton
                color="primary"
                size="small"
                onClick={() => {
                  setEditedNote(personChat.note);
                  setIsEditing(true);
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
              <IconButton color="error" size="small" onClick={handleDelete}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </>
          )}
        </Box>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="success"
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this note?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Chat;
